import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { FC, PropsWithChildren } from 'react';

interface Props {
  topBarContent: React.ReactNode;
}

export const Column: FC<PropsWithChildren<Props>> = ({ topBarContent, children }) => {
  const topBarHeight = topBarContent != null ? '35px' : '0px';
  return (
    <Container>
      <TopBar topBarHeight={topBarHeight}>{topBarContent}</TopBar>
      <Content topBarHeight={topBarHeight}>{children}</Content>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

const TopBar = styled.div<{ topBarHeight: string }>`
  height: ${({ topBarHeight }) => topBarHeight};
  min-height: ${({ topBarHeight }) => topBarHeight};
  max-height: ${({ topBarHeight }) => topBarHeight};
  border-bottom: solid 1px ${RacemapColors.LightGray};
`;

const Content = styled.div<{ topBarHeight: string }>`
  flex: 1;
  height: calc(100% - ${({ topBarHeight }) => topBarHeight});
`;
